import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from 'react'
import {createContext, ReactNode, useContext, useState} from "react";
import { uiConfigOptionsAttributes } from '../types'
import OrderConfiguration from '../features/orderConfiguration/OrderConfiguration';
import RenderSvg from '../components/renderSvg/RenderSvg';
import ThemeConfiguration from '../features/themeConfiguration/ThemeConfiguration';
import store from '../stateManagement/store';
import { sfaConfigOptions, uiConfigOptions } from '../components/uiConfigSidebar/UiConfigSidebar';
import { useSelector } from 'react-redux';
import Catalogue from '../features/salescodeStudio/mandatoryConfigs/optionalFeatures/catelogueConfig/Catalogue';

interface UiConfigOptionContextType {
    activeOption:uiConfigOptionsAttributes,
    setActiveOption:React.Dispatch<React.SetStateAction<uiConfigOptionsAttributes>>
}

const UiConfigOptionContext = createContext<UiConfigOptionContextType>({} as UiConfigOptionContextType);

const UiConfigOptionProvider = ({children}: { children: ReactNode }) => {
    const [activeOption, setActiveOption] = useState<uiConfigOptionsAttributes>({
        id: "Theme",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="ThemeConfigurationIcon" width="25%"/>,
        targetComponent: <Catalogue />,
    },)
    const portalLayoutConfigState = useSelector(() => store.getState()?.portalConfigState);

    useEffect(()=> {
        if(portalLayoutConfigState?.layoutConfig){ //setting first option as default 
            const uiConfigLayout = store.getState()?.portalConfigState?.layoutConfig.find((layoutConfig) => {
                return layoutConfig.name === "uiConfigLayout";
            })
            const uiConfigList = uiConfigLayout?.value;
            if(uiConfigList?.length){
                const firstUiConfigOption = uiConfigOptions.find((uiConfigOption) => {
                    return uiConfigOption.id === uiConfigList[0];
                })
                if(firstUiConfigOption) setActiveOption(firstUiConfigOption);
                else{
                    const firstSfaUiConfigOption = sfaConfigOptions.find((sfaConfigOption) => {
                        return sfaConfigOption.id === uiConfigList[0];
                    })
                    if(firstSfaUiConfigOption) setActiveOption(firstSfaUiConfigOption);
                }
            }
        }
    },[portalLayoutConfigState])
  return (
    <UiConfigOptionContext.Provider value={{activeOption,setActiveOption}}>
        {children}
    </UiConfigOptionContext.Provider>
  )
}

export function useUiConfigOption(): UiConfigOptionContextType {
    return useContext(UiConfigOptionContext);
}

export default UiConfigOptionProvider;

